module.exports = __webpack_public_path__ + "static/media/underline.77f5ba3b.svg";